import React, { memo } from 'react';
const categories = [{
  title: 'Shop All',
  href: '#shop',
  image: 'https://cdn.magicpatterns.com/uploads/3bmX1MJcmT5hep3B2FZyTq/IMG_0073.jpg'
}, {
  title: 'Cards',
  href: '#shop',
  image: 'https://cdn.magicpatterns.com/uploads/rWatCmjWdytf5HQGub38sH/IMG_0084.jpg'
}, {
  title: 'Memorabilia',
  href: '#memorabilia',
  image: 'https://cdn.magicpatterns.com/uploads/pGu6jpD4vc3TD4TQqA9843/IMG_0092.jpg'
}];
export const ShopByCategory = () => {
  return <section id="shop" className="py-16 md:py-24 bg-cream" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <h2 className="font-heading text-3xl md:text-4xl text-ink mb-10 text-center uppercase tracking-wide" data-id="element-137">
          Shop by Category
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-138">
          {categories.map((category, idx) => <a key={idx} href={category.href} className="group relative flex flex-col bg-white overflow-hidden border-4 border-ink shadow-comic hover:shadow-comic-hover hover:translate-x-[4px] hover:translate-y-[4px] transition-all duration-200" data-id="element-139">
              <div className="aspect-square bg-white overflow-hidden p-6 flex items-center justify-center border-b-4 border-ink" data-id="element-140">
                <img src={category.image} alt={category.title} className="object-contain w-full h-full group-hover:scale-105 transition-transform duration-500" data-id="element-141" />
              </div>
              <div className="bg-scarlet text-white p-4 text-center" data-id="element-142">
                <h3 className="font-heading text-xl md:text-2xl uppercase tracking-wider drop-shadow-[2px_2px_0px_rgba(0,0,0,1)]" data-id="element-143">
                  {category.title}
                </h3>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
};